<template>
<div class="vx-row">
    <div class="vx-col w-full">
        <vx-card>
            <ComunicadosPendientesVue/>
        </vx-card>
    </div>
    <div class="vx-col w-full  mb-6">
        <vx-card class="m-1" style="height: 500px;">
            <ReporteCiudadesVue/>
        </vx-card>
    </div>
    <!-- <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-6">
        <vx-card class="m-1" style="height: 500px;">
            <ReporteDocentesVue />
        </vx-card>
    </div> -->
    <!-- <div class="vx-col sm:w-1/3">
        <vx-card class="m-1">
            <vs-button icon-pack="feather" icon="icon-bookmark" color="primary"/> 
            <center>
                <p>Areas</p>
                <h2>{{ area }}</h2>
            </center>
        </vx-card>
    </div>
    <div class="vx-col sm:w-1/3">
        <vx-card class="m-1">
            <vs-button icon-pack="feather" icon="icon-layers" color="warning"></vs-button>
            <center>
                <p>Asignaturas</p>
                <h2>{{ asignatura }}</h2>
            </center>
        </vx-card>
    </div> -->
</div>
</template>
<script>
import ComunicadosPendientesVue from "./components/ComunicadosPendientes.vue";
import ReporteCiudadesVue from "./components/ReporteCiudades.vue";
import ReporteDocentesVue from '@/views/perfiles/components/ReporteDocentes'
import "vue-select/dist/vue-select.css";
import Vue from "vue";
import axios from "axios";
Vue.use(axios);
import chart from "vue-apexcharts";
export default {
    components: {
        apexchart: chart,
        ReporteCiudadesVue,
        ReporteDocentesVue,
        ComunicadosPendientesVue,
    },
    data() {
        return {
            area: [],
            asignatura: [],
            institucion: [],
            libro: [],
            planificacion: [],
            series: [{
                name: 'Reporte de trazabilidad',
                data: []
            }],
            options: {
                chart: {
                    height: 350,
                    type: 'bar',
                },
                plotOptions: {
                    bar: {
                        borderRadius: 10,
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val + ' horas.';
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ['#304758'],
                    },
                },

                xaxis: {
                    categories: [
                        'Anticipo aprobado',
                        'Generar Contrato',
                        'Recibe contabilidad',
                        'Cheque sin firmar',
                        'Cheque firmado',
                        'Recibe cheque'
                    ],
                    position: 'top',
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            },
                        },
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                yaxis: {
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                        formatter: function (val) {
                            return val + '%';
                        },
                    },
                },
                title: {
                    text: '',
                    floating: true,
                    offsetY: 330,
                    align: 'center',
                    style: {
                        color: '#444',
                    },
                },
            },

        };
    },
    mounted() {
        let me = this;
        me.f_inicio();
    },
    methods: {
        f_inicio(){
            let me = this;
            // console.log(me.options.xaxis.categories)
            me.options.xaxis.categories['Col 1'];
            // console.log(me.options.xaxis.categories)
        }
    },
};
</script>
